import { render, staticRenderFns } from "./FooterMenusCooloc.vue?vue&type=template&id=29865966"
import script from "./FooterMenusCooloc.vue?vue&type=script&lang=js"
export * from "./FooterMenusCooloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports